import FetchService from "@/services/fetch.service";

export default async function recursiveFetch(url: string, method: string) {
  const res = (await FetchService.fetchData(url, method)) as {
    success: boolean;
    count?: number;
    urls?: string[];
  };
  let success = !!res?.success;
  let count = 0;
  if (typeof res?.count == "number") count += res.count;

  if (typeof res == "object" && "urls" in res && Array.isArray(res?.urls)) {
    for (const url of res.urls){
        const recRes = await recursiveFetch(url, method);
        success = success && recRes.success;
        count += recRes.count;
    }
  }
  return { success, count };
}
